import React, { useState } from 'react';
import '../../css/huerto/scoring.css';
import { withRouter } from 'react-router-dom';
import ContractsService from '../../../services/ContractsService';
import { withCookies } from 'react-cookie';
import Loading from '../../bronson/Loading';
import Globals from '../../../Globals';
import CalculoLPA from './calculoLPA';
import ConcesionarioAcceso from './concesionarioAcceso';
import ContactoCliente from './contactoCliente';
import ActividadUsr from './actividadUsr';
import AsignacionVolumenVendedor from './asignacionVolumenVendedor';

function tableCreate(data, metrica) {
    var tbl = document.createElement('table');
    var tblBody = document.createElement('tbody');
    var keys_ = Object.keys(data[0]);
    var row_ = document.createElement('tr');
    var cell = document.createElement('td');
    keys_.forEach(element => {
        cell = document.createElement('td');
        cell.dataType = 'String';
        cell.appendChild(
            document.createTextNode(element !== null ? element.toString() : '')
        );
        row_.appendChild(cell);
    });
    tblBody.appendChild(row_);
    data.forEach(row => {
        row_ = document.createElement('tr');
        keys_.forEach(element => {
            cell = document.createElement('td');
            cell.appendChild(
                document.createTextNode(
                    row[element] !== null ? row[element].toString() : ''
                )
            );
            row_.appendChild(cell);
        });
        tblBody.appendChild(row_);
    });
    tbl.appendChild(tblBody);
    Exportar(tbl, metrica);
}

function Exportar(table, metrica) {
    var downloadLink;
    downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    var uri = 'data:application/vnd.ms-excel;base64; charset=UTF-8,',
        template =
            '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><meta http-equiv="content-type" content="application/vnd.ms-excel; charset=UTF-8"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64 = function (s) {
            return window.btoa(unescape(encodeURIComponent(s)));
        },
        format = function (s, c) {
            return s.replace(/{(\w+)}/g, function (m, p) {
                return c[p];
            });
        };

    var name = metrica + '.xls';
    var ctx = {
        worksheet: name || 'Worksheet',
        table: table.innerHTML,
        dataType: 'String',
    };
    downloadLink.href = uri + base64(format(template, ctx));
    downloadLink.download = name;
    downloadLink.click();
}

const MetricasHuerto = ({ cookies, history }) => {
    const [metricaLPA, setmetricaLPA] = useState(getMetricaPLA);
    const [metricaAccesoVendedor, setmetricaAccesoVendedor] = useState(
        getMetricaAccesoVendedor
    );
    const [metricaActividadDecision, setmetricaActividadDecision] = useState(
        getMetricaActividadDecision
    );
    const [metricaAccionesUSR, setmetricaMetricasAccionesUSR] = useState(
        getMetricasAccionesUSR
    );
    const [conceptoslogsMetricas, setconceptoslogsMetricas] = useState(
        getConceptologToMetricas
    );
    const [
        metricaAsignacionVolumenVendedor,
        setmetricaAsignacionVolumenVendedor,
    ] = useState(getAsignacionVolumenVendedorToMetricas);
    const [viewCalculoLPA, setviewCalculoLPA] = useState(false);
    const [viewconcesionarioAcceseo, setviewconcesionarioAcceseo] =
        useState(false);
    const [viewActividadDecision, setviewActividadDecision] = useState(false);
    const [viewActividadUsr, setviewActividadUsr] = useState(false);
    const [viewAsignacionVolumenVendedor, setviewAsignacionVolumenVendedor] =
        useState(false);
    const [loaded, setloaded] = useState(true);

    async function getAsignacionVolumenVendedorToMetricas() {
        var _response =
            await new ContractsService().getAsignacionVolumenVendedorToMetricas(
                cookies.get(Globals.COOKIES.JWT).AccessToken
            );
        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        ) {
            var response = JSON.parse(_response.body.Result);
            setmetricaAsignacionVolumenVendedor(response);
        }
    }
    async function getConceptologToMetricas() {
        var _response = await new ContractsService().getConceptologToMetricas(
            cookies.get(Globals.COOKIES.JWT).AccessToken
        );
        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        ) {
            var response = JSON.parse(_response.body.Result);
            setconceptoslogsMetricas(response);
        }
    }
    async function getMetricaPLA() {
        var _response = await new ContractsService().getMetricaPLA(
            cookies.get(Globals.COOKIES.JWT).AccessToken
        );
        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        ) {
            var response = JSON.parse(_response.body.Result);
            setmetricaLPA(response);
            if (
                metricaAccesoVendedor != null &&
                metricaActividadDecision != null
            )
                setloaded(false);
        }
    }
    async function getMetricaAccesoVendedor() {
        var _response = await new ContractsService().getMetricaAccesoVendedor(
            cookies.get(Globals.COOKIES.JWT).AccessToken
        );
        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        ) {
            var response = JSON.parse(_response.body.Result);
            setmetricaAccesoVendedor(response);
            if (metricaLPA != null && metricaActividadDecision != null)
                setloaded(false);
        }
    }
    async function getMetricaActividadDecision() {
        var _response =
            await new ContractsService().getMetricaActividadDecision(
                cookies.get(Globals.COOKIES.JWT).AccessToken
            );
        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        ) {
            var response = JSON.parse(_response.body.Result);
            setmetricaActividadDecision(response);
            if (metricaLPA != null && metricaAccesoVendedor != null)
                setloaded(false);
        }
    }
    async function getMetricasAccionesUSR() {
        var _response = await new ContractsService().getMetricasAccionesUSR(
            cookies.get(Globals.COOKIES.JWT).AccessToken
        );
        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        ) {
            var response = JSON.parse(_response.body.Result);
            setmetricaMetricasAccionesUSR(response);
        }
    }

    const printMetricaLPA = () => {
        var solicitadasCliente = 0;
        var noSolicitadasCliente = 0;
        try {
            metricaLPA.forEach(element => {
                if (element.POYINDSOLICITADOPORCLIENTE === 'N')
                    noSolicitadasCliente =
                        noSolicitadasCliente + element.NUMREGISTROS;
                else
                    solicitadasCliente =
                        solicitadasCliente + element.NUMREGISTROS;
            });
        } catch {}
        return (
            <section className="o-layout__item u-1/1 u-text-left">
                <div
                    className={
                        'gridContainer ' +
                        (solicitadasCliente > 0 || noSolicitadasCliente > 0
                            ? ''
                            : ' background-color-gray')
                    }
                >
                    <label
                        className="o-layout__item u-h3 u-ml-xsmall u-text-left"
                        style={{ width: '100%' }}
                    >
                        LPA calculadas
                    </label>
                    <label className="o-layout__item u-3/4 labelConsT u-text-muted">
                        LAP solicitadas por cliente
                    </label>
                    <label className="o-layout__item u-1/4 labelConsT u-text-base">
                        {solicitadasCliente}{' '}
                    </label>
                    <label className="o-layout__item u-3/4 labelConsT u-text-muted">
                        LAP solicitadas por vendedor
                    </label>
                    <label className="o-layout__item u-1/4 labelConsT u-text-base">
                        {noSolicitadasCliente}
                    </label>
                    <label className="o-layout__item u-3/4 labelConsT u-text-muted">
                        LPA totales simuladas
                    </label>
                    <label className="o-layout__item u-1/4 labelConsT u-text-base">
                        {solicitadasCliente + noSolicitadasCliente}
                    </label>
                    <label className="o-layout__item u-3/4 labelConsT u-text-muted">
                        Contratos Asociados
                    </label>
                    <label className="o-layout__item u-1/4 labelConsT u-text-base">
                        {metricaLPA.length}
                    </label>
                    <div className="o-layout__item u-1/1">
                        <span style={{ display: 'inline-flex' }}>
                            {(solicitadasCliente > 0 ||
                                noSolicitadasCliente > 0) && (
                                <label
                                    className="iconHover colorBlue"
                                    onClick={() =>
                                        setviewCalculoLPA(!viewCalculoLPA)
                                    }
                                >
                                    Ver detalle
                                </label>
                            )}
                            <i className="c-icon c-icon--[semantic-forward] c-icon--small iconHover colorBlue"></i>
                        </span>
                    </div>
                </div>
            </section>
        );
    };

    const printMetricaAccesoVendedor = () => {
        var rows = [];
        var numRegistros = 0;
        try {
            metricaAccesoVendedor.forEach(element => {
                rows.push(
                    <div key={rows.length}>
                        <label className="o-layout__item u-3/4 labelConsT u-text-muted">
                            {element.USCDESCPERFIL}
                        </label>
                        <label className="o-layout__item u-1/4 labelConsT u-text-base">
                            {element.NUMREGISTROS}{' '}
                        </label>
                    </div>
                );
                numRegistros += element.NUMREGISTROS;
            });
        } catch {}
        return (
            <section className="o-layout__item u-1/1 u-text-left">
                <div
                    className={
                        'gridContainer ' +
                        (metricaAccesoVendedor.length > 0
                            ? ''
                            : ' background-color-gray')
                    }
                >
                    <label
                        className="o-layout__item u-h3 u-ml-xsmall colorBlue u-text-left"
                        style={{ width: '100%' }}
                    >
                        Accesos por vendedor
                    </label>
                    {rows}
                    <label className="o-layout__item u-3/4 labelConsT u-text-muted">
                        Total de accesos
                    </label>
                    <label className="o-layout__item u-1/4 labelConsT u-text-base">
                        {numRegistros}{' '}
                    </label>
                    <div className="o-layout__item u-1/1">
                        <span style={{ display: 'inline-flex' }}>
                            {metricaAccesoVendedor.length > 0 && (
                                <label
                                    className="iconHover colorBlue"
                                    onClick={() =>
                                        setviewconcesionarioAcceseo(
                                            !viewconcesionarioAcceseo
                                        )
                                    }
                                >
                                    Ver detalle
                                </label>
                            )}
                            <i className="c-icon c-icon--[semantic-forward] c-icon--small iconHover colorBlue"></i>
                        </span>
                    </div>
                </div>
            </section>
        );
    };

    const printMetricaAisgnacionVolumenVendedor = () => {
        var asignados = 0;
        var asignados_defecto = 0;
        var noAsignados = 0;
        var autoAsignado = 0;
        try {
            metricaAsignacionVolumenVendedor.forEach(element => {
                if (element.PREASIGNADO === null) {
                    noAsignados += element.TOTALCONTRATOS;
                } else if (element.PREASIGNADO === 'N')
                    asignados += element.TOTALCONTRATOS;
                else if (element.PREASIGNADO === 'A')
                    autoAsignado += element.TOTALCONTRATOS;
                else asignados_defecto += element.TOTALCONTRATOS;
            });
        } catch {}
        return (
            <section className="o-layout__item u-1/1 u-text-left">
                <div
                    className={
                        'gridContainer ' +
                        (metricaAsignacionVolumenVendedor.length > 0
                            ? ''
                            : ' background-color-gray')
                    }
                >
                    <label
                        className="o-layout__item u-h3 u-ml-xsmall colorBlue u-text-left"
                        style={{ width: '100%' }}
                    >
                        Asignacion volumen vendedores
                    </label>
                    <label className="o-layout__item u-3/4 labelConsT u-text-muted">
                        PreAsignados
                    </label>
                    <label className="o-layout__item u-1/4 labelConsT u-text-base">
                        {asignados_defecto}{' '}
                    </label>{' '}
                    <label className="o-layout__item u-3/4 labelConsT u-text-muted">
                        Asignados JJVV
                    </label>
                    <label className="o-layout__item u-1/4 labelConsT u-text-base">
                        {asignados}{' '}
                    </label>{' '}
                    <label className="o-layout__item u-3/4 labelConsT u-text-muted">
                        AutoAsignados
                    </label>
                    <label className="o-layout__item u-1/4 labelConsT u-text-base">
                        {autoAsignado}{' '}
                    </label>{' '}
                    <label className="o-layout__item u-3/4 labelConsT u-text-muted">
                        No Asignados/Huerfanos
                    </label>
                    <label className="o-layout__item u-1/4 labelConsT u-text-base">
                        {noAsignados}
                    </label>
                    <div className="o-layout__item u-1/1">
                        <span style={{ display: 'inline-flex' }}>
                            {metricaAccesoVendedor.length > 0 && (
                                <label
                                    className="iconHover colorBlue"
                                    onClick={() =>
                                        setviewAsignacionVolumenVendedor(
                                            !viewAsignacionVolumenVendedor
                                        )
                                    }
                                >
                                    Ver detalle
                                </label>
                            )}
                            <i className="c-icon c-icon--[semantic-forward] c-icon--small iconHover colorBlue"></i>
                        </span>
                    </div>
                </div>
            </section>
        );
    };
    const printMetricaContactoCliente = () => {
        var numAcciones = 0;
        try {
            metricaActividadDecision.forEach(element => {
                numAcciones += element.NUMEROACCIONES;
            });
        } catch {}
        return (
            <section className="o-layout__item u-1/1 u-text-left">
                <div
                    className={
                        'gridContainer ' +
                        (metricaActividadDecision.length > 0
                            ? ''
                            : ' background-color-gray')
                    }
                >
                    <label
                        className="o-layout__item u-h3 u-ml-xsmall colorBlue u-text-left"
                        style={{ width: '100%' }}
                    >
                        Contactos con clientes
                    </label>
                    <label className="o-layout__item u-3/4 labelConsT u-text-muted">
                        Total de contactos
                    </label>
                    <label className="o-layout__item u-1/4 labelConsT u-text-base">
                        {metricaActividadDecision.length}{' '}
                    </label>
                    <label className="o-layout__item u-3/4 labelConsT u-text-muted">
                        Total de acciones
                    </label>
                    <label className="o-layout__item u-1/4 labelConsT u-text-base">
                        {numAcciones}{' '}
                    </label>
                    <div className="o-layout__item u-1/1">
                        <span style={{ display: 'inline-flex' }}>
                            {metricaActividadDecision.length > 0 && (
                                <label
                                    className="iconHover colorBlue"
                                    onClick={() =>
                                        setviewActividadDecision(
                                            !viewActividadDecision
                                        )
                                    }
                                >
                                    Ver detalle
                                </label>
                            )}
                            <i className="c-icon c-icon--[semantic-forward] c-icon--small iconHover colorBlue"></i>
                        </span>
                    </div>
                </div>
            </section>
        );
    };
    const printMetricaActividadUsr = () => {
        var cantidadAccionestoConcepto = [];
        var rows = [];

        try {
            conceptoslogsMetricas.forEach(element => {
                cantidadAccionestoConcepto.push([
                    element.TPNIDCONCEPTOLOG,
                    0,
                    element.TPCDESCRIPCION.split('-')[1],
                ]);
            });
            metricaAccionesUSR.forEach(element => {
                for (let i = 0; i < cantidadAccionestoConcepto.length; i++) {
                    if (
                        element.idConceptolog ===
                        cantidadAccionestoConcepto[i][0]
                    ) {
                        cantidadAccionestoConcepto[i][1]++;
                        break;
                    }
                }
            });
            cantidadAccionestoConcepto.forEach(element => {
                rows.push(
                    <div key={element[0]}>
                        <label className="o-layout__item u-3/4 labelConsT u-text-muted">
                            {element[2]}
                        </label>
                        <label className="o-layout__item u-1/4 labelConsT u-text-base">
                            {element[1]}
                        </label>
                    </div>
                );
            });
        } catch {}

        return (
            <section className="o-layout__item u-1/3 u-text-left">
                <div
                    className={
                        'gridContainer ' +
                        (metricaAccionesUSR.length > 0
                            ? ''
                            : ' background-color-gray')
                    }
                >
                    <label className="o-layout__item u-h3 u-ml-xsmall u-1/1 u-text-left">
                        Actividad vendedor
                    </label>
                    {rows}
                    <div className="o-layout__item u-1/1">
                        <span style={{ display: 'inline-flex' }}>
                            {metricaAccionesUSR.length > 0 && (
                                <label
                                    className="iconHover colorBlue"
                                    onClick={() =>
                                        setviewActividadUsr(!viewActividadUsr)
                                    }
                                >
                                    Ver detalle
                                </label>
                            )}
                            <i className="c-icon c-icon--[semantic-forward] c-icon--small iconHover colorBlue"></i>
                        </span>
                    </div>
                </div>
            </section>
        );
    };

    if (viewCalculoLPA)
        return (
            <div>
                <CalculoLPA
                    metricaLPA={metricaLPA}
                    setviewCalculoLPA={setviewCalculoLPA}
                    tableCreate={tableCreate}
                />
            </div>
        );
    else if (viewconcesionarioAcceseo)
        return (
            <ConcesionarioAcceso
                setviewconcesionarioAcceseo={setviewconcesionarioAcceseo}
                cookies={cookies}
                tableCreate={tableCreate}
            />
        );
    else if (viewActividadDecision) {
        return (
            <ContactoCliente
                setviewActividadDecision={setviewActividadDecision}
                metricaActividadDecision={metricaActividadDecision}
                tableCreate={tableCreate}
                cookies={cookies}
            />
        );
    } else if (viewActividadUsr) {
        return (
            <ActividadUsr
                setviewActividadUsr={setviewActividadUsr}
                metricaActividad={metricaAccionesUSR}
                tableCreate={tableCreate}
                conceptoslogsMetricas={conceptoslogsMetricas}
            />
        );
    } else if (viewAsignacionVolumenVendedor) {
        return (
            <AsignacionVolumenVendedor
                tableCreate={tableCreate}
                setviewAsignacionVolumenVendedor={
                    setviewAsignacionVolumenVendedor
                }
                metricaAsignacionVolumenVendedor={
                    metricaAsignacionVolumenVendedor
                }
                cookies={cookies}
            />
        );
    }

    return (
        <React.Fragment>
            <Loading ariaBusy={loaded}></Loading>
            <div className="u-pb-small u-rema-full-height">
                <section className="o-content-section o-page-wrap o-page-wrap--xsmall">
                    <div className="o-component-wrapper u-hide@s">
                        <h3 className="u-text-center">Metricas Huerto</h3>
                    </div>
                    <div className="o-layout__item  u-1/3">
                        {printMetricaLPA()}
                        {printMetricaContactoCliente()}
                    </div>
                    <div className="o-layout__item  u-1/3">
                        {printMetricaAccesoVendedor()}
                        {printMetricaAisgnacionVolumenVendedor()}
                    </div>

                    {printMetricaActividadUsr()}
                </section>
            </div>
        </React.Fragment>
    );
};

export default withCookies(withRouter(MetricasHuerto));
